'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var browser = {exports: {}};

exports.browser = browser;
